<template lang="pug">
  dv-form(
    ref="questionCriteriaForm"
    :schema="schema"
    v-slot="{ fields }"
  )
    v-row
      v-col(cols="12")
        h1.ui-h2.ui-neutral--text Критерии оценки
    v-row
      v-col(cols="12")
        dv-form-field(
          :field="fields.criterias"
        )
</template>

<script>
import DvForm from '@/packages/ui/components/forms/DvForm.vue';
import DvFormField from '@/packages/ui/components/forms/DvFormField.vue';

import CriteriaList from '../lists/CriteriaList.vue';

export default {
  components: {
    DvForm,
    DvFormField,
  },
  props: {
    namespace: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    schema() {
      return [
        {
          name: 'criterias',
          component: CriteriaList,
          value: this.namespace,
        },
      ];
    },
  },
};
</script>
